import { SubscriptionService } from 'api/subscription';
import { YouKassaPaymentPlugin } from 'integrations';
import { IYouKassaPaymentFormsApi } from 'integrations/youkassa/payments';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { LoadingComponent } from 'shared/components/loading';
import { SiteLayoutComponent, SiteSection } from 'shared/components/site-layout';
import { usePageMeta } from 'shared/mechanics/page-meta';
import { initPluggins } from 'shared/mechanics/plugin';
import { SubscriptionPaymentForm } from './components/paymentForm';

interface SubscriptionPayRouteParams {
	invoiceId: string;
}

initPluggins(YouKassaPaymentPlugin);

export const SubscriptionPayPage = () => {
	usePageMeta({
		title: 'Оплата',
		description: 'завершите оплату для получения статуса Инвестор+',
		keyWords: ['цена', 'оплата', 'подписки', 'paywall'],
		canonicalPath: 'subscription/pay' });

	const { invoiceId } = useParams<SubscriptionPayRouteParams>();
	const [confirmationToken, setConfirmationToken] = useState<string | null>(null);
	const [youKassaPaymentFormsApi, setYouKassaPaymentFormsApi] = useState<IYouKassaPaymentFormsApi | null>(null);

	useEffect(loadInvoiceData, [invoiceId]);
	useEffect(loadYouKassaPaymentFormsApi, []);

	if (confirmationToken === null || youKassaPaymentFormsApi === null)
		return <LoadingComponent />;

	return (
		<SiteLayoutComponent activeSection={SiteSection.None}>
			<SubscriptionPaymentForm confirmationToken={confirmationToken} formsApi={youKassaPaymentFormsApi} />
		</SiteLayoutComponent>
	);

	function loadInvoiceData() {
		SubscriptionService.createYouKassaPaymnent(invoiceId)
			.then(response => setConfirmationToken(response.confirmationToken))
			.catch(_ => alert('Не удалось получить данные платежа, попробуй повторить попытку позже'));
	}
	function loadYouKassaPaymentFormsApi() {
		YouKassaPaymentPlugin.createFormsApi()
			.then(api => setYouKassaPaymentFormsApi(api))
			.catch(_ => alert('Не удалось получить данные платежа, попробуй повторить попытку позже'));
	}
}